module.exports = __webpack_public_path__ + "webwave-1.png?27de0f6143cd3821343adfe7f7da8ce8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/webwave-1.png
// module id = 3s9u
// module chunks = 50